export default __webpack_public_path__ + "static/media/btn-googleplay.de2876b3.webp";